import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  newChart,
  setMetaData,
  setPageLoading,
} from 'containers/App/actions';
import Codebook from 'containers/Codebook';

const CodebookModal = (props) => {
  const {
    createNewChart,
    setLoading,
    foreground,
  } = props;

  return (
    <Modal
      foreground={foreground}
    >

      <Codebook
        onGenerateCdf={createNewChart}
        setLoading={setLoading}
      />
    </Modal>
  );
};

const Modal = styled.div`
  visibility: ${({ foreground }) => (foreground ? 'visible' : 'hidden')};
  z-index: 100;
  position: absolute;
  top: 80px;
  left: 0;
  height: calc(100vh - 80px);
  width: 100vw;
`;

const mapStateToProps = createStructuredSelector({
});

const mapDispatchToProps = (dispatch) => ({
  createNewChart: (cdf, metaData) => {
    dispatch(setMetaData(metaData, cdf.QuestionCode));
    dispatch(newChart(cdf));
  },
  setLoading: (value) => dispatch(setPageLoading(value)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

CodebookModal.propTypes = {
  foreground: PropTypes.bool,
  createNewChart: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default compose(
  withConnect
)(CodebookModal);



// WEBPACK FOOTER //
// ./app/containers/CodebookModal/index.js